/**
 * Sign up process.
 */

'use strict';

// Constructor
var FrontSignin = function () {
    $(document).ready((function () {
        this.initSlideAccount();
        this.initMobileMenu();

        if (!$('#modal-signin').length) {
            return;
        }

        this.initModalWindow();
        this.signinForm();
        this.showPasswordButton();
    }).bind(this));
};

FrontSignin.prototype = {
    lockAjaxForm: false,

    initModalWindow: function() {
        // Equal height for the left / right columns
        $('#modal-signin .inner').matchHeight();

        // Automatically open the modal window if the URL contain "#modal-signin"
        if (location.href.indexOf("#modal-signin") != -1) {
            $('#modal-signin').modal('open');
        }

        $('#modal-signin-close').on('click', function (e) {
            e.preventDefault();

            $('#modal-signin').modal('close');
        });
    },

    initSlideAccount: function() {
        $('#slide-my-account').sidenav({
            menuWidth: 400,
            edge: 'right',
            closeOnClick: true,
            draggable: false
        });
    },

    signinForm: function() {
        var self = this;
        var form = $('#modal-signin .signin form');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();
            $('.btn-passwordforgot', form).hide();
            $('.preloader-wrapper', form).fadeIn();

            $('#email', form).removeClass('invalid');
            $('#password', form).removeClass('invalid');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=signin.form&security=" + comedien.security,
            }).done(function(response) {
                if (response.success) {
                    var url = $('#redirectTo', form).val();
                    location.replace(url);
                } else {
                    $('#email', form).addClass('invalid');
                    $('#password', form).addClass('invalid');

                    if (response.data.pending == true) {
                        $('#modal-signin').modal('close');
                        $('#modal-signin-pending').modal('open');
                    } else if (response.data.deactivated == true || response.data.proAccessDateUntil == true) {
                        $('#modal-signin').modal('close');
                        $('#modal-signin-deactivated').modal('open');
                    }
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
                $('.btn-passwordforgot', form).show();
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
                $('.btn-passwordforgot', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Add a custom link in the mobile menu to allow the logged in user to log out.
     */
    initMobileMenu: function() {
        $('#mobile-menu').sidenav();
        $('#mobile-menu .mobile-only a').on('click', function(e) {
            if ($(this).attr('href') == comedien.homeUrl + '/logout') {
                var $logout = $('#slide-my-account #logout');

                if ($logout.length > 0) {
                    e.preventDefault();
                    window.location.replace($logout.attr('href'));
                }
            }
        });
    },

    /**
     * Add a button to allow the user to show his/her password in plan text on the signin modal window.
     */
    showPasswordButton: function() {
        var $inputPassword = $('#modal-signin #password');

        $('#modal-signin .show_password').on('mouseup', function() {
            $inputPassword.attr('type', 'password');
        }).on('mousedown', function() {
            $inputPassword.attr('type', 'text');
        });

        $('#modal-signin .show_password').on('touchend', function() {
            $inputPassword.attr('type', 'password');
        }).on('touchstart', function() {
            $inputPassword.attr('type', 'text');
        });
    }
};

module.exports = new FrontSignin();
